<template>
    <v-dialog v-model="dialogDelete" :width="getWidth" persistent>
        <v-card outlined>
            <v-toolbar dense flat>
                <v-toolbar-title class="text-h5" v-html="title"></v-toolbar-title>
            </v-toolbar>
            <v-card-text class="px-4 py-1 font14">
                <span v-html="confirmNotification"></span>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn :disabled="isActionDisabled" :color="declineButtonColor" text @click="cancel()">
                    {{ declineButtonText }}
                </v-btn>
                <v-btn
                    v-if="isDecline === false"
                    :loading="isActionDisabled"
                    :disabled="isActionDisabled"
                    :color="confirmButtonColor"
                    style="color: white"
                    elevation="0"
                    @click="deleteItem()"
                >
                    {{ confirmButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'app-dialogConfirm',
        props: {
            confirmText: {
                default: '',
                type: String,
            },
            confirmButton: undefined,
            confirmButtonColor: {
                default: '#6aa84f',
                type: String,
            },
            isActionDisabled: Boolean,
            isDecline: {
                default: false,
                type: Boolean,
            },
            declineButton: undefined,
            declineButtonColor: {
                default: 'grey',
                type: String,
            },
            width: {
                default: 300,
                type: Number,
            },
        },
        data() {
            return {
                confirmDefaultText: this.$t('action.deleteText'),
                title: this.$t('action.confirm'),
                dialogDelete: false,
                item: {},
            };
        },
        methods: {
            open() {
                this.dialogDelete = true;
            },
            close() {
                this.dialogDelete = false;
            },
            cancel() {
                // if (typeof this.beforeCancel === 'function') {
                //     this.beforeCancel();
                // }
                if (_.isEmpty(this.item)) {
                    this.$emit('cancel', this.close);
                } else {
                    this.$emit('cancel', {
                        closeCallback: this.close,
                        item: this.item,
                    });
                }
            },
            deleteItem() {
                if (_.isEmpty(this.item)) {
                    this.$emit('deleteItem', this.close);
                } else {
                    this.$emit('deleteItem', {
                        closeCallback: this.close,
                        item: this.item,
                    });
                }
            },
        },
        computed: {
            confirmButtonText() {
                if (this.confirmButton) {
                    return this.confirmButton;
                }

                return this.$t('action.yes');
            },
            confirmNotification() {
                return this.confirmText ? this.confirmText : this.confirmDefaultText;
            },
            declineButtonText() {
                if (this.declineButton) {
                    return this.declineButton;
                }

                return this.$t('action.no');
            },

            // eslint-disable-next-line vue/return-in-computed-property
            getWidth() {
                if (this.$props.width) {
                    return this.$props.width;
                }
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return 220;
                    case 'sm':
                        return 400;
                    case 'md':
                        return 500;
                    case 'lg':
                        return 600;
                    case 'xl':
                        return 800;
                }
            },
        },
    };
</script>
